import React, { useEffect, useRef, useState } from 'react'
import Select from 'react-select';

import {
  FieldProps,
  GroupProps,
} from '../../utils/functionsInterfaces'

import { handleAddField } from '../../functions/addFieldStandard'
import { handleAddAttachmentsFieldOutsideGroup } from '../../functions/addFieldAttachmentsNotGroup'
import { handleAddFieldAttachments } from '../../functions/addFieldAttachments'
import { handleAddFieldOutsideGroup } from '../../functions/addFieldStandardNotGroup'
import { handleAddGroup } from '../../functions/addGroup'
import { handleAddPersonalDetailField } from '../../functions/addFieldPersonalDetails'
import { handleAddPersonalDetailFieldOutsideGroup } from '../../functions/addFieldPersonalDetailsNotGroup'
import { handleCopyGroup } from '../../functions/copyGroup'
import { handleRemoveField } from '../../functions/removeField'
import { handleRemoveFieldInGroup } from '../../functions/removeFieldInGroup'
import { handleRemoveGroup } from '../../functions/removeGroup'
import { formatNameAlias } from '../../functions/formatNameAlias'
import { getFormSideProps } from '../../functions/getFormSideProps'
import { getSkillId } from '../../functions/getSkill'
import { getTabId } from '../../functions/getTab'
import { publishForm } from '../../functions/publishForm'
import { saveForm } from '../../functions/updateForm'
import { toggleGroupVisibility } from '../../functions/toggleGroupVisibility'
import { fetchCreatePayload, generatePayload } from '../../functions/generatePayload'
import { generateJSON } from '../../functions/generateJSON'
import { createProtocol } from '../../functions/createProtocol'

import {
  handleInputAliasChange,
  handleInputItemIdChange,
  handleInputNameChange,
  handleInputSkillChange,
  handleInputTabChange,
} from '../../utils/functionsInputs'

import { useAuthContext } from '../../hooks/auth'
import { useClearAppCachesOnMount } from '../../hooks/useClearAppCachesOnMount'
import { Helmet } from 'react-helmet-async';
import { DragDropContext, Draggable, Droppable, DropResult } from '@hello-pangea/dnd'
import { useLocation } from 'react-router-dom'
import { ButtonAddAttachmentsFieldOutsideGroup, ButtonAddField, ButtonAddFieldAttachments, ButtonAddFieldOutsideGroup, ButtonAddGroup, ButtonCopyGroup, ButtonCopyIdForm, ButtonCopyItemIdForm, ButtonCopyText, ButtonCreateProtocol, ButtonGenerateJson, ButtonGeneratePayload, ButtonPublishForm, ButtonRemoveGroup, ButtonSaveForm } from '../../components/ui/buttons'
import { InputsInfosGroups, InputsInfosPages } from '../../components/ui/inputs'
import FormGroups from '../../components/FormGroups'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp, faGear, faGripVertical, faLayerGroup, faUser } from '@fortawesome/free-solid-svg-icons'
import { Field } from '../../components/fields'
import { fieldsPersonalDetails } from '../../functions/personalDetails'
import { displayError, displaySuccess, displayWarning } from '../../utils/messageToast'
import Modal from '../../components/ui/modal'

export default function Form({ create, mode }: { create: boolean, mode: string }) {
  const { authorization, authorizationForce, authorizationRA, user } = useAuthContext();
  const clientId = user?.clientId as string
  const ambient = user?.ambient as string;

  const personalDetails = fieldsPersonalDetails();

  const [form, setForm] = useState<any[]>([...personalDetails]);

  const [nameForm, setNameForm] = useState('');
  const [pageId, setPageId] = useState(create ? 'data' : '');
  const [namePage, setNamePage] = useState(create ? 'Data' : '');
  const [skillIdForm, setSkillIdForm] = useState('');
  const [tabIdForm, setTabIdForm] = useState('');
  const [formId, setFormId] = useState('');

  const structureForm = {
    id: pageId,
    name: namePage,
    type: "page",
    template: {
      children: [...form],
    }
  };

  const [isInForce, setIsInForce] = useState(user?.inForce as boolean);
  const token = isInForce ? authorizationForce : authorizationRA;
  const [groups, setGroups] = useState<GroupProps[]>([])
  const [fields, setFields] = useState<FieldProps[]>([])
  const [search, setSearch] = useState('')
  const [showTopContainer, setShowTopContainer] = useState(false)
  const [expandedGroups, setExpandedGroups] = useState<string[]>([])
  const [showTopPageContainer, setShowTopPageContainer] = useState(true)
  const [skillName, setSkillName] = useState('')
  const [tabName, setTabName] = useState('')
  const [itemId, setItemId] = useState('')
  const [aliasFormResult, setAliasFormResult] = useState('')
  const [checkTheFunction, setCheckTheFunction] = useState(true)
  const [idFormSaved, setIdFormSaved] = useState('')
  const [buttonSave, setButtonSave] = useState(false)
  const [buttonPublish, setButtonPublish] = useState(false)
  const [addFieldPersonalDetails, setAddFieldPersonalDetails] = useState('')
  const [loadingButtonSave, setLoadingButtonSave] = useState(false);
  const [loadingButtonPublish, setLoadingButtonPublish] = useState(false);
  const [loadingButtonGeneratePayload, setLoadingButtonGeneratePayload] = useState(false);
  const [loadingButtonGenerateJson, setLoadingButtonGenerateJson] = useState(false);
  const [searchFormId, setSearchFormId] = useState('');
  const [isData, setIsData] = useState(false)
  const [isCreated, setIsCreated] = useState(create ? true : false)
  const [expandedPage, setExpandedPage] = useState(true)
  const [customerDetailsOption, setCustomerDetailsOption] = useState('')
  const [selectedOption, setSelectedOption] = useState<CustomerDetailsOption | null>(null);
  const [dupCounts, setDupCounts] = useState<Record<string, number>>({});
  const [dupOpen, setDupOpen] = useState<Record<string, boolean>>({});
  const [createProtocolModalOpen, setCreateProtocolModalOpen] = useState(false);
  const [createProtocolLoading, setCreateProtocolLoading] = useState(false);
  const [protocolPayloadJson, setProtocolPayloadJson] = useState('');
  const [protocolPayloadError, setProtocolPayloadError] = useState<string | null>(null);
  const [protocolPayloadFetchLoading, setProtocolPayloadFetchLoading] = useState(false);
  const [createProtocolSubmitError, setCreateProtocolSubmitError] = useState<string | null>(null);
  const [createProtocolResultText, setCreateProtocolResultText] = useState<string | null>(
    null
  );
  const initialPayloadForHistoryRef = useRef<any>(null);
  const titlePage = create ? 'Criacao de formulário' : 'Edição de formulário'

  const getDupCount = (key?: string) => {
    if (!key) return 1;
    return Math.max(1, dupCounts[key] ?? 1);
  };

  const setDupCount = (key: string | undefined, value: number) => {
    if (!key) return;
    const next = Math.min(Math.max(Math.floor(value || 1), 1), 200);
    setDupCounts((prev) => ({ ...prev, [key]: next }));
  };

  const isDupOpen = (key?: string) => {
    if (!key) return false;
    return !!dupOpen[key];
  };

  const toggleDupOpen = (key: string | undefined, open?: boolean) => {
    if (!key) return;
    setDupOpen((prev) => ({ ...prev, [key]: typeof open === 'boolean' ? open : !prev[key] }));
  };

  useEffect(() => {
    const closeOnClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.closest('.form-group-dup') || target.closest('.form-group-dup-trigger')) return;
      setDupOpen({});
    };
    document.addEventListener('mousedown', closeOnClickOutside);
    return () => document.removeEventListener('mousedown', closeOnClickOutside);
  }, []);

  const location = useLocation();

  useClearAppCachesOnMount();

  useEffect(() => {
    const interval = setInterval(() => {
      const storedInForce = localStorage.getItem("inForce") === "true";
      if (storedInForce !== isInForce) {
        setIsInForce(storedInForce);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [isInForce]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const fromListForms = queryParams.get('formId');
    if (!fromListForms || !token || !clientId || !ambient) return;
    setSearchFormId(fromListForms);
    getFormSideProps(
      setExpandedPage,
      setShowTopPageContainer,
      setNamePage,
      setPageId,
      setIsData,
      fromListForms,
      setFormId,
      setNameForm,
      setSkillIdForm,
      setTabIdForm,
      setItemId,
      setGroups,
      setFields,
      setShowTopContainer,
      setButtonPublish,
      clientId,
      setAliasFormResult,
      setForm,
      ambient,
      setSkillName,
      token,
      setTabName,
      isInForce,
      (payload) => { initialPayloadForHistoryRef.current = payload; },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, token, clientId, ambient]);

  const generateJson = async () => {
    setLoadingButtonGenerateJson(true)
    const json = generateJSON(
      undefined,
      isCreated,
      pageId,
      formId,
      nameForm,
      skillIdForm,
      tabIdForm,
      aliasFormResult,
      form
    )
    navigator.clipboard.writeText(
      JSON.stringify(json, null, 2)
    );
    displaySuccess("Template do formulário copiado para a área de transferência!")
    setLoadingButtonGenerateJson(false)
  }

  const formatCreateProtocolResponse = (data: unknown): string => {
    if (data === null || data === undefined) return '';
    if (typeof data === 'string') return data;
    const d = data as Record<string, unknown>;
    if (typeof d.protocol === 'string') return d.protocol;
    if (d.protocol != null && typeof d.protocol === 'object') {
      return JSON.stringify(d.protocol, null, 2);
    }
    if (d.protocol != null) return String(d.protocol);
    return JSON.stringify(data, null, 2);
  };

  const closeCreateProtocolModal = () => {
    setCreateProtocolModalOpen(false);
    setProtocolPayloadJson('');
    setProtocolPayloadError(null);
    setCreateProtocolResultText(null);
    setCreateProtocolSubmitError(null);
  };

  const openCreateProtocolModal = async () => {
    setCreateProtocolModalOpen(true);
    setCreateProtocolResultText(null);
    setCreateProtocolSubmitError(null);
    setProtocolPayloadJson('');
    setProtocolPayloadError(null);
    const alias = formId?.trim();
    if (!alias) {
      const msg =
        'Informe e salve o ID do formulário — o mesmo usado no botão "Gerar payload".';
      setProtocolPayloadError(msg);
      displayWarning(
        'É necessário o ID do formulário para obter o payload gerado pela API.'
      );
      return;
    }
    setProtocolPayloadFetchLoading(true);
    const payload = await fetchCreatePayload(
      clientId,
      authorization,
      ambient,
      alias
    );
    setProtocolPayloadFetchLoading(false);
    if (payload === undefined) {
      const msg =
        'Não foi possível obter o payload. Verifique o ID do formulário e tente novamente.';
      setProtocolPayloadError(msg);
      displayError('Erro ao obter o payload para criar o protocolo.');
      return;
    }
    const base = payload as Record<string, unknown>;
    const existingCustomer = base.customer;
    const customer =
      existingCustomer && typeof existingCustomer === 'object' && !Array.isArray(existingCustomer)
        ? { ...(existingCustomer as Record<string, unknown>) }
        : {};
    const withCustomer = {
      ...base,
      customer: {
        document: String(customer.document ?? ''),
        email: String(customer.email ?? ''),
        name: String(customer.name ?? ''),
        phone:
          customer.phone === undefined || customer.phone === ''
            ? null
            : customer.phone,
      },
    };
    setProtocolPayloadJson(JSON.stringify(withCustomer, null, 2));
  };

  const handleConfirmCreateProtocol = async () => {
    setCreateProtocolSubmitError(null);
    if (protocolPayloadFetchLoading || protocolPayloadError) {
      setCreateProtocolSubmitError('Aguarde o carregamento do payload ou corrija o erro exibido acima.');
      return;
    }
    if (!protocolPayloadJson.trim()) {
      setCreateProtocolSubmitError('Não há payload para enviar. Aguarde o carregamento ou corrija o erro acima.');
      return;
    }
    let payload: Record<string, unknown>;
    try {
      payload = JSON.parse(protocolPayloadJson) as Record<string, unknown>;
    } catch {
      setCreateProtocolSubmitError('JSON do payload inválido. Verifique a sintaxe antes de enviar.');
      return;
    }
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
      setCreateProtocolSubmitError('O payload deve ser um objeto JSON.');
      return;
    }
    const customer = payload.customer as Record<string, unknown> | undefined;
    const filledCustomerFields = [
      customer?.document,
      customer?.email,
      customer?.name,
      customer?.phone,
    ].filter((value) => {
      if (value == null) return false;
      return String(value).trim().length > 0;
    });
    if (filledCustomerFields.length < 2) {
      setCreateProtocolSubmitError(
        'Preencha pelo menos 2 campos em customer (document, email, name ou phone) no JSON antes de enviar.'
      );
      return;
    }
    setCreateProtocolLoading(true);
    try {
      const result = await createProtocol(payload, ambient, token, true);
      if (result !== undefined) {
        setCreateProtocolResultText(formatCreateProtocolResponse(result));
        displaySuccess('Protocolo criado com sucesso!');
      }
    } catch (err: any) {
      const data = err?.response?.data;
      const base: string =
        data?.message || data?.error || err?.message || 'Erro ao criar protocolo. Tente novamente.';
      const errorsObj = data?.errors;
      let msg = base;
      if (errorsObj && typeof errorsObj === 'object') {
        const lines = Object.values(errorsObj as Record<string, string>).join('\n');
        if (lines) msg = `${base}\n\n${lines}`;
      }
      setCreateProtocolSubmitError(msg);
    } finally {
      setCreateProtocolLoading(false);
    }
  };

  const onDragEnd = (result: DropResult) => {
    const { source, destination } = result;

    if (!destination) return;

    const updatedForm = [...form];

    const isSourceMainGroup = source.droppableId === 'droppable-page';
    const isDestMainGroup = destination.droppableId === 'droppable-page';

    const sourceGroupIndex = isSourceMainGroup
      ? -1
      : updatedForm.findIndex(group => group.uuid === source.droppableId);

    const destGroupIndex = isDestMainGroup
      ? -1
      : updatedForm.findIndex(group => group.uuid === destination.droppableId);

    let movedItem: any;

    if (isSourceMainGroup) {
      movedItem = updatedForm.splice(source.index, 1)[0];
    } else {
      const sourceGroup = updatedForm[sourceGroupIndex];
      if (Array.isArray(sourceGroup.children)) {
        movedItem = sourceGroup.children.splice(source.index, 1)[0];
      }
    }

    if (isDestMainGroup) {
      updatedForm.splice(destination.index, 0, movedItem);
    } else {
      const destGroup = updatedForm[destGroupIndex];
      if (!Array.isArray(destGroup.children)) {
        destGroup.children = [];
      }
      destGroup.children.splice(destination.index, 0, movedItem);
    }

    setForm(updatedForm);
    setButtonSave(true);
  };

  const clientOptionsCustomerDetails = [
    { value: 'customerSocialNumber', label: 'Document' },
    { value: 'customerEmail', label: 'Email' },
    { value: 'customerPhoneNumber', label: 'Phone' },
    { value: 'customerName', label: 'Name' }
  ];

  interface CustomerDetailsOption {
    value: string;
    label: string;
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div>

        <Helmet>
          <title>{titlePage}</title>
        </Helmet>

        <div className="bg-page-update-form w-full px-2 sm:px-4 md:px-6 py-4 form-page">
          <div className="form-page-shell">
            <div className="form-config-card">
              <div className="form-card-header">
                <div className="form-card-header-left">
                  <span className="form-card-icon">
                    <FontAwesomeIcon icon={faGear} />
                  </span>
                  <div>
                    <h2 className="form-card-title">Configurações do Formulário</h2>
                    <p className="form-card-subtitle">Defina os parâmetros globais do formulário</p>
                  </div>
                </div>
                <span className="form-card-badge">{create ? 'Novo formulário' : 'Editando'}</span>
              </div>

              <div className="form-card-body">
                <div className="infos-form-header w-full space-y-3 sm:space-y-4">

                  {!create &&
                    <div className="form-info-row">
                      <label className="form-info-label">ItemId</label>
                      <div className="header-fields-item flex-1 w-full flex gap-2">
                        <InputsInfosPages
                          placeholder='Insira o ItemId'
                          type='text'
                          value={itemId}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                            handleInputItemIdChange(event, setItemId)
                          }
                          disabled={true}
                          style={{ cursor: 'not-allowed', flex: 1 }}
                        />
                        <ButtonCopyItemIdForm itemId={itemId as string} />
                      </div>
                    </div>
                  }

                  <div className="form-info-row">
                    <label className="form-info-label">Nome</label>
                    <div className="header-fields-item flex-1 w-full">
                      <InputsInfosPages
                        placeholder='Insira o nome do formulário'
                        type='text'
                        value={nameForm}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                          handleInputNameChange(event, setNameForm)
                        }
                        onBlur={() => {
                          formatNameAlias(nameForm, setAliasFormResult)
                          setNamePage(nameForm)
                          setButtonSave(true)
                        }}
                        style={{ flex: 1 }}
                      />
                      <ButtonCopyText value={nameForm} label="Nome do formulário copiado!" />
                    </div>
                  </div>

                  <div className="form-info-row">
                    <label className="form-info-label">Alias</label>
                    <div className="header-fields-item flex-1 w-full">
                      <InputsInfosPages
                        placeholder='Insira o alias'
                        type='text'
                        value={aliasFormResult}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                          handleInputAliasChange(event, setAliasFormResult)
                        }
                        onBlur={() => {
                          setButtonSave(true)
                        }}
                        style={{ flex: 1 }}
                      />
                      <ButtonCopyText value={aliasFormResult} label="Alias copiado!" />
                    </div>
                  </div>

                  <div className="form-info-row">
                    <label className="form-info-label">SkillId</label>
                    <div className="header-fields-item flex-1 w-full">
                      <InputsInfosPages
                        placeholder='Insira a skillId'
                        type='text'
                        value={skillIdForm}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                          handleInputSkillChange(event, setSkillIdForm)
                        }
                        onBlur={() => {
                          getSkillId(skillIdForm, token, ambient, setSkillName, isInForce)
                          setButtonSave(true)
                        }}
                        style={{ flex: 1 }}
                      />
                      <ButtonCopyText value={skillIdForm} label="SkillId copiado!" />
                    </div>
                  </div>

                  <div className="form-info-row">
                    <label className="form-info-label">TabId</label>
                    <div className="header-fields-item flex-1 w-full">
                      <InputsInfosPages
                        placeholder='Insira a tabId'
                        type='text'
                        value={tabIdForm}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                          handleInputTabChange(event, setTabIdForm)
                        }
                        onBlur={() => {
                          getTabId(tabIdForm, token, ambient, setTabName, isInForce, skillIdForm)
                          setButtonSave(true)
                        }}
                        style={{ flex: 1 }}
                      />
                      <ButtonCopyText value={tabIdForm} label="TabId copiado!" />
                    </div>
                  </div>

                </div>

                <div className="form-actions-bar">
                  <div className="form-actions-left">
                    <ButtonAddGroup onClick={() => handleAddGroup(setForm, setButtonSave)} />
                    <ButtonAddFieldOutsideGroup onClick={() => handleAddFieldOutsideGroup(setForm, setButtonSave)} />
                    <ButtonAddAttachmentsFieldOutsideGroup onClick={() => handleAddAttachmentsFieldOutsideGroup(setForm, setButtonSave)} />
                  </div>

                  <div className="form-actions-right">
                    <div className="form-actions-select">
                      <FontAwesomeIcon icon={faUser} className="form-actions-select-icon" />
                      <Select<CustomerDetailsOption>
                        options={clientOptionsCustomerDetails}
                        value={selectedOption}
                        onChange={(newValue) => {
                          if (newValue && 'value' in newValue) {
                            setCustomerDetailsOption(newValue.value);
                            setSelectedOption(newValue);
                            handleAddPersonalDetailFieldOutsideGroup(
                              form,
                              setForm,
                              newValue.value,
                              setAddFieldPersonalDetails,
                              setButtonSave
                            )
                          } else {
                            setCustomerDetailsOption('');
                            setSelectedOption(null);
                          }
                        }}
                        placeholder="Customer"
                        inputId="customer-details-select-search"
                        className="form-actions-react-select"
                        styles={{
                          container: (base) => ({
                            ...base,
                            minWidth: '130px',
                            maxWidth: '200px',
                            width: '100%',
                          }),
                          control: (base) => ({
                            ...base,
                            minHeight: '36px',
                            paddingLeft: '1.5rem',
                          }),
                        }}
                        classNamePrefix="react-select"
                      />
                    </div>

                    <span className="form-actions-divider" />

                    <ButtonSaveForm
                      loading={loadingButtonSave}
                      buttonSave={buttonSave}
                      onClick={() =>
                        saveForm(
                          setLoadingButtonSave,
                          generateJSON(
                            structureForm,
                            isCreated,
                            pageId,
                            formId,
                            nameForm,
                            skillIdForm,
                            tabIdForm,
                            aliasFormResult,
                            form
                          ),
                          authorization,
                          token,
                          setButtonPublish,
                          setButtonSave,
                          setIdFormSaved,
                          nameForm,
                          skillIdForm,
                          tabIdForm,
                          aliasFormResult,
                          ambient,
                          setTabName,
                          setSkillName,
                          setForm,
                          !create ? initialPayloadForHistoryRef.current : undefined,
                          user?.google?.id,
                          user?.google?.name ?? user?.userName ?? null,
                          user?.clientId ?? null,
                          user?.clientName ?? null,
                          isInForce,
                        )
                      } />

                    <ButtonPublishForm
                      loading={loadingButtonPublish}
                      buttonPublish={buttonPublish}
                      onClick={() => publishForm(
                        setExpandedPage,
                        setShowTopPageContainer,
                        setNamePage,
                        setPageId,
                        setIsData,
                        setLoadingButtonPublish,
                        idFormSaved,
                        setSearch,
                        setFormId,
                        setNameForm,
                        setSkillIdForm,
                        setTabIdForm,
                        setItemId,
                        setGroups,
                        setFields,
                        setShowTopContainer,
                        setButtonSave,
                        setButtonPublish,
                        clientId,
                        token,
                        aliasFormResult,
                        setAliasFormResult,
                        setForm,
                        checkTheFunction,
                        ambient,
                        setTabName,
                        setSkillName,
                        token,
                        isInForce,
                      )
                      }
                    />

                    {!create &&
                      <>
                        <ButtonGeneratePayload
                          loading={loadingButtonGeneratePayload}
                          onClick={() =>
                            generatePayload(
                              setLoadingButtonGeneratePayload,
                              clientId,
                              authorization,
                              ambient,
                              formId
                            )}
                        />

                        <ButtonGenerateJson
                          loading={loadingButtonGenerateJson}
                          onClick={generateJson}
                        />

                        <ButtonCreateProtocol
                          onClick={() => void openCreateProtocolModal()}
                        />
                      </>
                    }
                  </div>
                </div>
              </div>
            </div>

            <div className="form-structure-card">
              <div className="form-structure-card-header">
                <div>
                  <h3 className="form-card-title">Estrutura do Formulário</h3>
                  <p className="form-card-subtitle">Organize grupos e campos do formulário</p>
                </div>
              </div>

              <div className="bg-form-content w-full mt-2">

                <div className="form-page-section">
                  <div className="form-page-section-header">
                    <div>
                      <span className="form-page-section-label">Formulário atual</span>
                      <p className="form-page-section-helper">Tudo abaixo pertence a este formulário</p>
                    </div>
                  </div>

                  <div className="form-structure-page">
                    <div className="form-structure-page-icon">
                      <FontAwesomeIcon icon={faLayerGroup} />
                    </div>

                    <div className="form-structure-page-inputs">
                      <InputsInfosGroups
                        placeholder='Digite o ID da pagina'
                        value={pageId}
                        onChange={(e) => {
                          setPageId(e.target.value)
                        }}
                        onBlur={() => {
                          setButtonSave(true)
                        }}
                      />

                      <InputsInfosGroups
                        placeholder='Digite o nome da pagina'
                        value={namePage}
                        onChange={(e) => {
                          setNamePage(e.target.value)
                        }}
                        onBlur={() => {
                          setButtonSave(true)
                        }}
                      />
                    </div>

                    <button
                      type='button'
                      onClick={() => {
                        setExpandedPage(!expandedPage)
                      }}
                      className="form-structure-toggle"
                      title='Esconder Campos'
                    >
                      {expandedPage ? (
                        <FontAwesomeIcon icon={faAngleUp} />
                      ) : (
                        <FontAwesomeIcon icon={faAngleDown} />
                      )}
                    </button>

                  </div>

                  {expandedPage &&
                    <Droppable droppableId={`droppable-page`} type='page'>
                      {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps} className="form-page-section-body">
                          {(form.filter((i: any) => !i._deleted) as any[]).map((item: any, index: number) => (
                            <Draggable
                              key={item.uuid}
                              draggableId={item.uuid}
                              index={index}
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  {item.type === 'group' ? (
                                    <div key={index} className={`form-group-card ${item.isNew ? 'is-new' : ''}`}>

                                      <div className="form-group-header">
                                        <div className="form-group-header-left">
                                          <span className="form-field-drag" title="Arraste para reordenar">
                                            <FontAwesomeIcon icon={faGripVertical} />
                                          </span>
                                          <span className="form-group-icon">
                                            <FontAwesomeIcon icon={faLayerGroup} />
                                          </span>
                                          <div className="form-group-inputs">
                                            <InputsInfosGroups
                                              placeholder='Digite o ID do grupo'
                                              value={item.id}
                                              onChange={(e) => {
                                                const newId = e.target.value
                                                const updatedForm = form.map((group: any) => {
                                                  if (group.uuid === item.uuid) {
                                                    return { ...group, id: newId }
                                                  }
                                                  return group
                                                })
                                                setForm(updatedForm)
                                              }}
                                              onBlur={() => {
                                                setButtonSave(true)
                                              }}
                                            />

                                            <InputsInfosGroups
                                              placeholder='Digite o nome do grupo'
                                              value={item.name}
                                              onChange={(e) => {
                                                const newName = e.target.value
                                                const updatedForm = form.map((group: any) => {
                                                  if (group.uuid === item.uuid) {
                                                    return { ...group, name: newName }
                                                  }
                                                  return group
                                                })
                                                setForm(updatedForm)
                                              }}
                                              onBlur={() => {
                                                setButtonSave(true)
                                              }}
                                            />
                                          </div>
                                        </div>

                                        <div className="form-group-actions">
                                          <ButtonAddField
                                            onClick={() => {
                                              handleAddField(
                                                item.uuid,
                                                expandedGroups,
                                                form,
                                                setForm,
                                                setButtonSave
                                              )
                                              setExpandedGroups([...expandedGroups, item.uuid])
                                            }}
                                          />

                                          <ButtonAddFieldAttachments
                                            onClick={() => {
                                              handleAddFieldAttachments(
                                                item.uuid,
                                                expandedGroups,
                                                form,
                                                setForm,
                                                setButtonSave
                                              )
                                              setExpandedGroups([...expandedGroups, item.uuid])
                                            }}
                                          />

                                          {isDupOpen(item.uuid) && (
                                            <div className="form-group-dup">
                                              <input
                                                type="number"
                                                min={1}
                                                max={200}
                                                value={getDupCount(item.uuid)}
                                                onChange={(e) => setDupCount(item.uuid, Number(e.target.value))}
                                                onBlur={() => toggleDupOpen(item.uuid, false)}
                                                title="Quantidade para duplicar"
                                              />
                                              <span>x</span>
                                            </div>
                                          )}

                                          <span className="form-group-dup-trigger">
                                            <ButtonCopyGroup
                                              onClick={() => {
                                                if (!isDupOpen(item.uuid)) {
                                                  toggleDupOpen(item.uuid, true);
                                                  return;
                                                }
                                                handleCopyGroup(
                                                  item.id,
                                                  item.name,
                                                  form,
                                                  setForm,
                                                  item.uuid || '',
                                                  setButtonSave,
                                                  getDupCount(item.uuid)
                                                );
                                                toggleDupOpen(item.uuid, false);
                                              }}
                                            />
                                          </span>

                                          <ButtonRemoveGroup
                                            onClick={() =>
                                              handleRemoveGroup(
                                                item.id,
                                                form,
                                                setForm,
                                                item.uuid,
                                                setButtonSave
                                              )
                                            }
                                          />

                                          <button
                                            type='button'
                                            onClick={() =>
                                              toggleGroupVisibility(
                                                item.uuid || '',
                                                expandedGroups,
                                                setExpandedGroups
                                              )
                                            }
                                            className="form-structure-toggle"
                                            title='Esconder Campos'
                                          >
                                            {
                                              expandedGroups.includes(item.uuid) ? (
                                                <FontAwesomeIcon icon={faAngleUp} />
                                              ) : (
                                                <FontAwesomeIcon icon={faAngleDown} />
                                              )}
                                          </button>
                                        </div>
                                      </div>

                                      {expandedGroups.includes(item.uuid) && (
                                        <div className="form-group-body">
                                          <FormGroups
                                            form={form}
                                            setForm={setForm}
                                            groups={groups}
                                            expandedGroups={expandedGroups}
                                            setExpandedGroups={setExpandedGroups}
                                            handleCopyGroup={handleCopyGroup}
                                            handleRemoveGroup={handleRemoveGroup}
                                            handleAddField={handleAddField}
                                            handleAddFieldAttachments={handleAddFieldAttachments}
                                            handleAddPersonalDetailField={handleAddPersonalDetailField}
                                            handleRemoveField={handleRemoveField}
                                            handleRemoveFieldInGroup={handleRemoveFieldInGroup}
                                            toggleGroupVisibility={toggleGroupVisibility}
                                            setAddFieldPersonalDetails={setAddFieldPersonalDetails}
                                            addFieldPersonalDetails={addFieldPersonalDetails}
                                            setButtonSave={setButtonSave}
                                            authorization={authorization}
                                            clientId={clientId}
                                            ambient={ambient}
                                            formId={formId}
                                            item={item}
                                            outsideTheGroup={false}
                                            index={index}
                                            isPersonalDetails={false}
                                            structureForm={structureForm}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  ) : item.fieldType === 'multiple_files' ? (
                                    /* campo de anexo fora do grupo */
                                    <Field
                                      fieldGroupInGroup={item}
                                      indexFieldGroupInGroup={index}
                                      index={index}
                                      field={item}
                                      handleRemoveFieldInGroup={handleRemoveFieldInGroup}
                                      handleRemoveField={handleRemoveField}
                                      form={form}
                                      setForm={setForm}
                                      outsideTheGroup={true}
                                      isPersonalDetail={false}
                                      setButtonSave={setButtonSave}
                                      authorization={authorization}
                                      clientId={clientId}
                                      ambient={ambient}
                                      formId={formId}
                                      groupId={pageId}
                                    />
                                  ) : item.fieldType === 'personal_details' ? (
                                    /* campo personal details fora do grupo */
                                    <div key={index}>
                                      <Field
                                        fieldGroupInGroup={item}
                                        indexFieldGroupInGroup={index}
                                        index={index}
                                        field={item}
                                        handleRemoveFieldInGroup={handleRemoveFieldInGroup}
                                        handleRemoveField={handleRemoveField}
                                        form={form}
                                        setForm={setForm}
                                        outsideTheGroup={true}
                                        isPersonalDetail={true}
                                        setButtonSave={setButtonSave}
                                        authorization={authorization}
                                        clientId={clientId}
                                        ambient={ambient}
                                        formId={formId}
                                        groupId={undefined}
                                      />
                                    </div>
                                  ) : (
                                    <Field
                                      fieldGroupInGroup={item}
                                      indexFieldGroupInGroup={index}
                                      index={index}
                                      field={item}
                                      handleRemoveFieldInGroup={handleRemoveFieldInGroup}
                                      handleRemoveField={handleRemoveField}
                                      form={form}
                                      setForm={setForm}
                                      outsideTheGroup={true}
                                      isPersonalDetail={false}
                                      setButtonSave={setButtonSave}
                                      authorization={authorization}
                                      clientId={clientId}
                                      ambient={ambient}
                                      formId={formId}
                                      groupId={pageId}
                                    />
                                  )}

                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  }

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {createProtocolModalOpen && (
        <Modal
          isOpen={createProtocolModalOpen}
          title={
            createProtocolResultText !== null ? 'Protocolo criado' : 'Criar protocolo'
          }
          contentClassName="modal-content-wide"
          loading={createProtocolLoading}
          hideActions={createProtocolResultText !== null}
          showHeaderClose={createProtocolResultText !== null}
          confirmText="Enviar"
          cancelText="Cancelar"
          onConfirm={handleConfirmCreateProtocol}
          onClose={() => {
            if (!createProtocolLoading) closeCreateProtocolModal();
          }}
          disableBackdropClose={createProtocolLoading}
        >
          {createProtocolResultText !== null ? (
            <>
              <p className="create-protocol-modal-hint">
                Protocolo retornado pela API. Use o botão abaixo para copiar.
              </p>
              <div className="create-protocol-copy-row">
                <button
                  type="button"
                  className="modalButton"
                  onClick={() => {
                    void navigator.clipboard.writeText(createProtocolResultText);
                    displaySuccess('Protocolo copiado para a área de transferência!');
                  }}
                >
                  Copiar protocolo
                </button>
              </div>
              <pre
                className="create-protocol-payload-preview"
                aria-label="Protocolo"
              >
                {createProtocolResultText}
              </pre>
            </>
          ) : (
            <>
              {protocolPayloadFetchLoading && (
                <p className="create-protocol-modal-hint" role="status">
                  Carregando o mesmo payload do botão &quot;Gerar payload&quot;…
                </p>
              )}
              {!protocolPayloadFetchLoading && (
                <p className="create-protocol-modal-hint">
                  O corpo da requisição vem de <code>/create-payload</code> (
                  <code>form</code>, <code>client</code>, <code>payloadOrigin</code>, etc.).
                  Edite o JSON abaixo antes de enviar — incluindo pelo menos 2 campos em{' '}
                  <code>customer</code> (document, email, name ou phone).
                </p>
              )}
              {protocolPayloadError && !protocolPayloadFetchLoading && (
                <p className="create-protocol-modal-error" role="alert">
                  {protocolPayloadError}
                </p>
              )}

              <label className="form-info-label" htmlFor="protocol-payload-json" style={{ marginTop: '1rem', display: 'block' }}>
                Payload da requisição (JSON editável)
              </label>
              <textarea
                id="protocol-payload-json"
                className="create-protocol-payload-preview create-protocol-payload-editor"
                aria-label="Payload JSON editável"
                value={protocolPayloadJson}
                onChange={(e) => {
                  setProtocolPayloadJson(e.target.value);
                  if (createProtocolSubmitError) setCreateProtocolSubmitError(null);
                }}
                disabled={protocolPayloadFetchLoading || !!protocolPayloadError}
                spellCheck={false}
                rows={20}
                placeholder={
                  protocolPayloadFetchLoading
                    ? 'Carregando…'
                    : protocolPayloadError
                      ? ''
                      : 'Aguarde o carregamento do payload…'
                }
              />
              {createProtocolSubmitError && (
                <pre
                  className="create-protocol-modal-error"
                  role="alert"
                  style={{ marginTop: '0.75rem', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                >
                  {createProtocolSubmitError}
                </pre>
              )}
            </>
          )}
        </Modal>
      )}
    </DragDropContext>
  )
}